// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { UpdateAvailableToast } from "@/components/layout/update-available-toast";
import { Toaster } from "@/components/ui/sonner";
import { toasterPropsFor, useAssistantFootprint } from "@/features/assistant/footprint";

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  const assistantFootprint = useAssistantFootprint();
  return (
    <div className="h-screen overflow-hidden bg-background text-foreground">
      <Outlet />
      <Toaster {...toasterPropsFor(assistantFootprint)} />
      <UpdateAvailableToast />
    </div>
  );
}
